<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <Card>
                    <div class="row mb-4">
                        <h5 class="col-sm-12 col-md-10 text-bold">{{ __('Shipping documents export') }}</h5>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Date of receipt') }}:</dt>
                                    <dd>{{ dateFormat(shippingDocument.date) }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Carrier') }}:</dt>
                                    <dd>{{ shippingDocument.carrierCustomer.label }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Transport ID number') }}:</dt>
                                    <dd>{{ shippingDocument.transport }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Sender') }}:</dt>
                                    <dd>{{ shippingDocument.senderCustomer.label }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Recipient') }}:</dt>
                                    <dd>{{ shippingDocument.receiverCustomer.label }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Recipient address') }}:</dt>
                                    <dd>{{ shippingDocument.receiverAddress }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-12">&nbsp;</div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">
                                    <dt>{{ __('Status') }}:</dt>
                                    <dd>{{ shippingDocument.state.label }}</dd>
                                </div>
                            </div>
                        </div>

                        <div class="hidden-sm col-md-2"></div>

                        <div class="col-sm-12 col-md-5">
                            <div class="row">
                                <div class="col-12">

                                </div>
                            </div>
                        </div>
                    </div>

                    <ShipmentsOverview :shipments="shippingDocument.shipments"/>

                </Card>
                <br/>
                <div class="row">
                    <div class="col-12 text-right">
                        <button
                            @click="$router.push('/shipping-documents')"
                            class="btn btn-sm btn-info col-sm-6 col-md-4"
                        >
                            {{ __('Back') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapMutations } from 'vuex'
import { $api } from '../../services/api'
import ShipmentsOverview from '../Releases/ShipmentsOverview'

export default {
  name: 'ShippingDocumentView',

  components: { ShipmentsOverview },

  beforeRouteEnter (to, from, next) {
    $api.shipping.item(to.params.id).then((shippingDocument) => {
      next((vm) => {
        vm.setShippingDocument(shippingDocument.data)
      })
    })
  },

  computed: {
    ...mapGetters('ShippingDocumentModule', [
      'shippingDocument'
    ])
  },

  methods: {
    ...mapMutations('ShippingDocumentModule', [
      'setShippingDocument'
    ]),

    dateFormat (item) {
      return moment(item).format('YYYY-MM-DD')
    },
  }
}
</script>
